import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "audio-chat-page"
};
export default {
  __name: 'Test',
  setup(__props) {
    const connect = () => {};
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        style: {
          "margin": "20px"
        },
        type: "primary",
        size: "large",
        onClick: _cache[0] || (_cache[0] = $event => connect())
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("开始语音对话")])),
        _: 1
      })]);
    };
  }
};